require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./urgences-1-9-0.json") })
        }
      }, "path---urgences-1-9-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---urgences-1-9-0!./.cache/json/urgences-1-9-0.json
// module id = 596
// module chunks = 231608221292675